import React, { Component } from 'react';
import { observer } from 'mobx-react';

import SignupDialogState from 'js/stores/SignupDialogState';
import Form from './Form';

@observer
export default class Signup extends Component {
  signupDialogState = SignupDialogState.create();

  after = email => {
    if (this.props.after) {
      this.props.after(email);
    } else {
      this.signupDialogState.showVerification();
    }
  };

  render() {
    const { marketing } = this.props;

    return (
      <Form
        predicate={this.props.predicate}
        before={this.props.before}
        after={this.after}
        submitLabel={this.props.submitLabel}
        referral={this.props.referral}
        page={this.props.page}
        marketing={marketing}
      />
    );
  }
}
